import getAcademicYear from "app/helpers/getAcademicYear";
import getNestedValue from "app/helpers/getNestedValue";
import clsx from "clsx";
import moment from "moment";
import { FC, ReactNode, useState } from "react";
import { useIntl } from "react-intl";

interface ITableHeader {
  label: string | number;
}

interface IBodyItem {
  [key: string]: ReactNode | any;
}

interface Props {
  title: string;
  header: ITableHeader[];
  body: IBodyItem[];
  bodyKey: string[];
  forPaginationData?: {
    links: {
      next: string;
      previous: string;
    };
    total_items: number;
    total_pages: number;
    page_size: number;
    current_page: number;
  };
  setUrl?: any;
  openUrl?: string;
}

export const Table: FC<Props> = ({
  title,
  header,
  body,
  bodyKey,
  forPaginationData,
  setUrl,
}) => {
  const { formatMessage } = useIntl();
  const itemsPerPage = 10;
  const num = forPaginationData?.total_pages
    ? forPaginationData.total_pages
    : 0;
  const pagesArray = Array(num)
    .fill(0)
    .map((_, i) => {
      return (num / num) * (i + 1);
    });

  const handleNext = () => {
    if (forPaginationData?.links.next) {
      setUrl(forPaginationData.links.next);
    }
  };

  const handlePrevious = () => {
    if (forPaginationData?.links.previous) {
      setUrl(forPaginationData.links.previous);
    }
  };

  return (
    <>
      <div className="border bg-white rounded-3">
        <div className="w-100 py-7 px-6 border-bottom">
          <h1 className="fs-3">{formatMessage({ id: title })}</h1>
        </div>
        <table className="table mb-0 table-row-bordered gy-7 gs-7">
          <thead>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
              {header.map(({ label }) => (
                <th>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {body.map((item, index) => (
              <tr key={index}>
                {bodyKey.map((subItem) => (
                  <td key={subItem} className="text-nowrap">
                    {subItem === "actions" ? (
                      item[subItem]
                    ) : subItem === "status" ? (
                      <>status</>
                    ): subItem === "title" ? (
                            <>{item[subItem]}</>
                        ): subItem === "report.text" ? (
                        <>status</>
                    ) : subItem === "id" ? (
                      <>
                        {(forPaginationData?.current_page
                          ? forPaginationData.current_page - 1
                          : 0) *
                          itemsPerPage +
                          index +
                          1}
                      </>
                    ) : subItem === "created_at" ? (
                      <>{getAcademicYear(item[subItem])}</>
                    ) : (
                      <>
                        {getNestedValue(item, subItem)
                          ? getNestedValue(item, subItem)
                          : item[subItem]}
                      </>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {forPaginationData && (
        <ul className="pagination mt-5">
          <li
            className={clsx(
              "page-item previous",
              !forPaginationData.links.previous && "disabled"
            )}
            onClick={handleNext}
          >
            <a href="#" className="page-link">
              <i className="previous"></i>
            </a>
          </li>
          {pagesArray.map((p) => (
            <li
              className={clsx(
                "page-item",
                p === forPaginationData.current_page && "active"
              )}
            >
              <a href="#" className="page-link">
                {p}
              </a>
            </li>
          ))}
          <li
            className={clsx(
              `page-item next`,
              !forPaginationData.links.next && "disabled"
            )}
            onClick={handlePrevious}
          >
            <a href="#" className="page-link">
              <i className="next"></i>
            </a>
          </li>
        </ul>
      )}
    </>
  );
};
